/**
 * Die uebrigen Core-Entitaeten: Benutzer, Tag, Datei (KONZEPT.md §9.3).
 */
import { z } from "zod";
import { Id, KurzText, Zeitpunkt } from "./basis.js";
import { Rolle } from "./enums.js";
/**
 * Benutzer (KONZEPT.md §4).
 *
 * Kein Passwort und kein Hash im Vertrag: Module duerfen Benutzer lesen, aber
 * niemals Anmeldedaten sehen oder eine eigene Anmeldung bauen (§3.3).
 */
export const Benutzer = z.object({
    id: Id,
    benutzername: z
        .string()
        .trim()
        .min(2)
        .max(60)
        .regex(/^[a-z0-9._-]+$/, "Nur Kleinbuchstaben, Ziffern, Punkt, Strich und Unterstrich"),
    anzeigename: KurzText,
    rolle: Rolle,
    aktiv: z.boolean(),
    angelegt_am: Zeitpunkt,
});
export const Tag = z.object({
    id: Id,
    name: z.string().trim().min(1).max(60),
});
/**
 * Datei oder Foto (KONZEPT.md §9.3, Datenschutz §17).
 *
 * `nur_intern` ist kein Beiwerk: Personen- und Zustandsfotos erscheinen auf
 * keinem geteilten Dokument. Das Kennzeichen haengt an der Datei und nicht am
 * Verwendungsort, damit es nicht verlorengeht, wenn eine Datei
 * weiterverwendet wird.
 */
export const Datei = z.object({
    id: Id,
    dateiname: KurzText,
    medientyp: z.string().trim().max(120),
    groesse_bytes: z.number().int().nonnegative(),
    /** SHA-256 in Hexadezimalschreibweise -- erkennt doppelte Uploads. */
    pruefsumme: z.string().regex(/^[0-9a-f]{64}$/),
    nur_intern: z.boolean(),
    angelegt_von: Id,
    angelegt_am: Zeitpunkt,
});
//# sourceMappingURL=stammdaten.js.map